
import styles from "./tip.module.css"
import { useNavigate } from "react-router";
import { Provider, Root, Trigger, Portal, Content, Arrow } from "@radix-ui/react-tooltip";
export const Tip = ({ item }) => {
    const navigate = useNavigate()
    return (
        <Provider>
            <Root delayDuration={200} >
                <Trigger asChild>
                    <button onClick={() => navigate(`/product/${item?.id}`)} className={styles.IconButton}>
                        {item?.name}
                    </button>
                </Trigger>
                <Portal>
                    <Content className={styles.Content} sideOffset={5}>
                        <img src={item?.img} alt={item?.name} width={40} height={40} />
                    </Content>
                </Portal>
            </Root>
        </Provider>
    );
};